import classNames from 'classnames';
import { Card } from '../../Cards';
import { AvatarLarge, HeadingLine, Line, Space, SubHeadingLine } from '../Blocks';
import { Gradient, GradientContainer, Mask } from '../Layers/index';
import styles from '../Layers/style.m.less';

function DefaultStyle() {
    return (
        <div className={styles.container}>
            <Gradient className={styles.sentence}>
                <Mask className={styles.contentImageGap} />
                <Mask className={styles.contentSentenceGap} />
            </Gradient>
            <div className="card">
                <Gradient>
                    <Mask className={styles.headerL} />
                    <Mask className={styles.headerR} />
                    <Mask className={styles.headerGap} />
                    <Mask className={styles.subHeaderL} />
                    <Mask className={styles.subHeaderR} />
                    <Mask className={styles.contentTop} />
                    <Mask className={styles.contentFirstEnd} />
                    <Mask className={styles.contentSecondLine} />
                    <Mask className={styles.contentSecondEnd} />
                </Gradient>
            </div>
        </div>
    );
}
function TodoStyle() {
    return (
        <div className={classNames(styles.container, styles.todo)}>
            <Gradient className={styles.sentence}>
                <Mask className={styles.contentSentenceGap} />
            </Gradient>
            <div className="card">
                <Gradient className={styles.cardContent}>
                    <Mask className={styles.headerL} />
                    <Mask className={styles.headerR} />
                    <Mask className={styles.headerGap} />
                    <Mask className={styles.subHeaderL} />
                    <Mask className={styles.subHeaderR} />
                    <Mask className={styles.contentSecondEnd} />
                </Gradient>
            </div>
        </div>
    );
}

function PlainCardStyle() {
    return (
        <div className={classNames(styles.container, styles.plainCard)}>
            <div className="card">
                <Gradient className={styles.cardContent}>
                    <Mask className={styles.headerGap} />
                    <Mask className={styles.subHeaderR} />
                    <Mask className={styles.contentTop} />
                    <Mask className={styles.contentFirstEnd} />
                    <Mask className={styles.contentSecondLine} />
                    <Mask className={styles.contentSecondEnd} />
                    <Mask className={styles.contentThirdLine} />
                    <Mask className={styles.contentThirdEnd} />
                </Gradient>
            </div>
        </div>
    );
}

function PraiseStyle() {
    return (
        <Card>
            <GradientContainer>
                <Space />
                <AvatarLarge centered />
                <Space />
                <HeadingLine centered width={60} />
                <Space />
                <Space />
                <SubHeadingLine />
                <SubHeadingLine width={70} />
                <Space />
                <Line />
                <Line />
                <Line />
            </GradientContainer>
        </Card>
    );
}

export { DefaultStyle, PlainCardStyle, PraiseStyle, TodoStyle };
